// Screenshots in public/images/portfolio/ are captured from the live homepages
// (desktop at 1440px, mobile at 390px). Re-capture them when a site changes.
export const FEATURED_PROJECTS = [
  {
    name: 'Cherry Creek Co',
    category: 'Custom e-commerce',
    summary: 'A distinctive storefront connecting a custom-built website with Shopify commerce.',
    detail: 'Custom storefront · Shopify integration',
    url: 'https://www.cherrycreekco.com.au/',
    desktop: '/images/portfolio/cherry-creek-desktop.webp',
    mobile: '/images/portfolio/cherry-creek-mobile.webp',
    desktopAlt: 'Cherry Creek Co homepage on desktop: dark hero photo of handcrafted crackers and cheese on a rustic outdoor table, with Shop Now and Our Story buttons',
    mobileAlt: 'Cherry Creek Co homepage on mobile: stacked hero headline, product photography and full-width Shop Now button',
  },
  {
    name: 'Spectrum Writing',
    category: 'Custom web application',
    summary: 'A tailored website supporting program discovery, registrations and operational workflows.',
    detail: 'Program information · Registrations · Attendance tools',
    url: 'https://spectrumwriting.com.au/',
    desktop: '/images/portfolio/spectrum-writing-desktop.webp',
    mobile: '/images/portfolio/spectrum-writing-mobile.webp',
    desktopAlt: 'Spectrum Writing homepage on desktop: "You Belong At Our Table" hero with Register Interest and View Programs buttons, followed by program cards',
    mobileAlt: 'Spectrum Writing homepage on mobile: hero headline with stacked registration buttons and program introduction',
  },
  {
    name: 'Midway Road Community House',
    category: 'Headless CMS website',
    summary: 'A community-focused website with flexible content management for programs, events and resources.',
    detail: 'Headless CMS · Events · Community programs',
    url: 'https://midwayroadcommunityhouse.com.au/',
    desktop: '/images/portfolio/midway-road-desktop.webp',
    mobile: '/images/portfolio/midway-road-mobile.webp',
    desktopAlt: 'Midway Road Community House homepage on desktop: community hero photo with Find Support button and image-led "How can we help you today?" navigation tiles',
    mobileAlt: 'Midway Road Community House homepage on mobile: hero with full-width Find Support button and two-column help tiles',
  },
]

// Intrinsic sizes of the WebP files, so the browser reserves space before they load.
export const SCREENSHOT_SIZE = {
  desktop: { width: 960, height: 1334 },
  mobile: { width: 390, height: 1700 },
}
